<div class="mt-5">
    <app-services-block></app-services-block>
</div>
<div class="mt-5 inverse-background pt-5 pb-5 mb-5">
    <h1 class="text-center">My Process<span class="highlight">.</span></h1>
    <p class="subheading">Although no project or business is the same there are some commonalities that need to be explored between successful and unsuccessful products and teams.</p>
    <app-detailed-services-block></app-detailed-services-block>
</div>